import { SelectOption } from "../common/general";

export const officeOptions: SelectOption[] = [
    {value: '0', item: '東京本社'},
    {value: '1', item: '大阪支社'},
    {value: '2', item: '北九州LAB'}
];